<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="6">
          <CCard class="p-4 text-center">
            <CCardBody>
              <div v-if="status === 'loading'">
                <CSpinner
                  color="primary"
                  style="width: 3rem; height: 3rem"
                  class="mb-3"
                />
                <h3>Verifying your request...</h3>
                <p class="text-muted">
                  Please wait while we process your token.
                </p>
              </div>

              <div v-else-if="status === 'success'">
                <CIcon
                  name="cil-check-circle"
                  class="text-success mb-3"
                  size="3xl"
                />
                <h3>Success!</h3>
                <p class="text-muted">
                  {{ message }}
                </p>
                <CButton
                  color="primary"
                  class="mt-3"
                  @click="goToLogin"
                >
                  Go to Login
                </CButton>
              </div>

              <div v-else-if="status === 'error'">
                <CIcon
                  name="cil-x-circle"
                  class="text-danger mb-3"
                  size="3xl"
                />
                <h3>Verification Failed</h3>
                <p class="text-muted">
                  {{ message }}
                </p>
                <CButton
                  color="secondary"
                  class="mt-3"
                  @click="goToLogin"
                >
                  Return to Home
                </CButton>
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
export default {
  name: 'VerifyEmail',
  data() {
    return {
      status: 'loading',
      message: '',
      type: '',
      token: '',
    };
  },
  mounted() {
    this.type = this.$route.query.type;
    this.token = this.$route.query.hash;

    if (this.type && this.token) {
      this.verifyToken();
    } else {
      this.status = 'error';
      this.message = 'The verification link is invalid or incomplete.';
    }
  },
  methods: {
    verifyToken() {
      const endpoint =
        this.type === 'old'
          ? `/admins/email/verify-old/${this.token}`
          : `/admins/email/verify-new/${this.token}`;

      this.$http
        .get(endpoint)
        .then(({ data }) => {
          this.status = 'success';
          this.message = data.message || 'Verification successful.';
        })
        .catch(({ response }) => {
          this.status = 'error';
          this.message =
            response?.data?.message || 'The verification link is invalid or has expired.';
        });
    },
    goToLogin() {
      if (this.$auth.check()) {
        this.$router.push({ name: 'Dashboard' }).catch(() => {});
      } else {
        this.$router.push({ name: 'Login' }).catch(() => {});
      }
    },
  },
};
</script>

<style scoped>
.c-icon.c-icon-3xl {
  width: 4rem;
  height: 4rem;
}
</style>
